"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _SurvivorNew = _interopRequireDefault(require("../model/SurvivorNew"));

var _SurvivorResp = _interopRequireDefault(require("../model/SurvivorResp"));

var _SurvivorUpdateRequest = _interopRequireDefault(require("../model/SurvivorUpdateRequest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Survivor service.
* @module api/SurvivorApi
* @version 1.0.0
*/
var SurvivorApi = /*#__PURE__*/function () {
  /**
  * Constructs a new SurvivorApi. 
  * @alias module:api/SurvivorApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function SurvivorApi(apiClient) {
    _classCallCheck(this, SurvivorApi);

    this.apiClient = apiClient || _ApiClient.default.instance;
  }
  /**
   * list survivors
   * @param {Object} opts Optional parameters
   * @param {Number} opts.page 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */


  _createClass(SurvivorApi, [{
    key: "apiV1SurvivorsGetWithHttpInfo",
    value: function apiV1SurvivorsGetWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'page': opts['page']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/survivors', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * list survivors
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1SurvivorsGet",
    value: function apiV1SurvivorsGet(opts) {
      return this.apiV1SurvivorsGetWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * get survivor
     * @param {String} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1SurvivorsIdGetWithHttpInfo",
    value: function apiV1SurvivorsIdGetWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling apiV1SurvivorsIdGet");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/survivors/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * get survivor
     * @param {String} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1SurvivorsIdGet",
    value: function apiV1SurvivorsIdGet(id) {
      return this.apiV1SurvivorsIdGetWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * update survivor
     * @param {String} id id
     * @param {Object} opts Optional parameters
     * @param {module:model/SurvivorUpdateRequest} opts.survivorUpdateRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1SurvivorsIdPatchWithHttpInfo",
    value: function apiV1SurvivorsIdPatchWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['survivorUpdateRequest']; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling apiV1SurvivorsIdPatch");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/survivors/{id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * update survivor
     * @param {String} id id
     * @param {Object} opts Optional parameters
     * @param {module:model/SurvivorUpdateRequest} opts.survivorUpdateRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1SurvivorsIdPatch",
    value: function apiV1SurvivorsIdPatch(id, opts) {
      return this.apiV1SurvivorsIdPatchWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * update survivor
     * @param {String} id id
     * @param {Object} opts Optional parameters
     * @param {module:model/SurvivorUpdateRequest} opts.survivorUpdateRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1SurvivorsIdPutWithHttpInfo",
    value: function apiV1SurvivorsIdPutWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['survivorUpdateRequest']; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling apiV1SurvivorsIdPut");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/survivors/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * update survivor
     * @param {String} id id
     * @param {Object} opts Optional parameters
     * @param {module:model/SurvivorUpdateRequest} opts.survivorUpdateRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1SurvivorsIdPut",
    value: function apiV1SurvivorsIdPut(id, opts) {
      return this.apiV1SurvivorsIdPutWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * create survivor
     * @param {Object} opts Optional parameters
     * @param {module:model/SurvivorNew} opts.survivorNew 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SurvivorResp} and HTTP response
     */

  }, {
    key: "apiV1SurvivorsPostWithHttpInfo",
    value: function apiV1SurvivorsPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['survivorNew'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _SurvivorResp.default;
      return this.apiClient.callApi('/api/v1/survivors', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * create survivor
     * @param {Object} opts Optional parameters
     * @param {module:model/SurvivorNew} opts.survivorNew 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SurvivorResp}
     */

  }, {
    key: "apiV1SurvivorsPost",
    value: function apiV1SurvivorsPost(opts) {
      return this.apiV1SurvivorsPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return SurvivorApi;
}();

exports.default = SurvivorApi;